/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
// Descuentos.jsx es de donde me baso
import React, { useState, useEffect } from 'react';
import {
  Row,
} from 'antd';

import DiasFestivosPorAñoReloj from './Reloj/Dias Festivos/DiasFestivosPorAñoReloj';

export const diasFestivosRelojPermission = {
  permissionModel: 'diafestivo',
  catalogsModels: [],
  tabsModels: [],
};

const DiasFestivosReloj = ({ permission }) => (
  <Row className="container">
    <DiasFestivosPorAñoReloj
      permission={permission}
    />
  </Row>
);

export default DiasFestivosReloj;
